import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { BLANK_IMAGE_URL, BLANK_NO_USER_IMAGE_URL, } from '@/define/consts/assets';
import { IS_MODE_REGRESSION } from '@/define/env';
import { useBoolState } from '@/hooks/state/useBoolState';
const objectPositions = {
    contain: 'object-contain',
    cover: 'object-cover',
    fill: 'object-fill',
};
const objectCovers = {
    // 必要に応じて追加
    center: 'object-center',
    top: 'object-top',
};
export const ImageBase = (props) => {
    const { alt, className = '', heightClassName = 'h-full', imageHeight, imageWidth, isBlur = false, isGrayScale = false, isHoverZoom = false, isLazyLoad = true, noImageSrc = BLANK_IMAGE_URL, objectCover = 'center', objectPosition = 'fill', pictureClassName = '', src, webpSrc = '', widthClassName = 'w-full', } = props;
    const { boolState: isNoImage, changeTrue: onError } = useBoolState({
        initialState: !src && !webpSrc,
    });
    // NOTE: imgタグの imageWidth, imageHeight, aspect-ratio 指定はレイアウトシフト防止用
    // WARNING: スタイルを整える場合は別途 width, height 等のスタイル指定用の class を渡してください
    // WARNING: 画像比率に関しては img タグに aspect-ratio の class は渡さず、親要素で調整してください
    const aspectRatio = imageWidth && imageHeight
        ? css `
          aspect-ratio: ${imageWidth} / ${imageHeight};
        `
        : undefined;
    // NO IMAGE用の高さ制御
    const noImageSize = (() => {
        switch (noImageSrc) {
            // 通常のNO IMAGEの場合
            case BLANK_IMAGE_URL: {
                return {
                    height: 140,
                    width: 122,
                };
            }
            // ユーザー画像用のNO IMAGE
            case BLANK_NO_USER_IMAGE_URL: {
                return {
                    height: 256,
                    width: 256,
                };
            }
            // その他
            default: {
                return {
                    height: imageHeight,
                    width: imageWidth,
                };
            }
        }
    })();
    /** img用のclassName */
    const baseClassName = clsx('block', heightClassName, widthClassName, objectCovers[objectCover], isBlur && 'blur-sm', isGrayScale && 'grayscale', isHoverZoom &&
        'transition-[transform] hover:scale-125 group-hover:scale-125', className);
    /** img用のloading設定 */
    const imgLoading = !IS_MODE_REGRESSION && isLazyLoad ? 'lazy' : 'eager';
    return (_jsx("picture", Object.assign({ className: pictureClassName }, { children: isNoImage ? (_jsx("img", { alt: alt, className: clsx(noImageSrc === BLANK_IMAGE_URL && 'bg-gray-100', baseClassName, objectPositions.contain), css: aspectRatio, height: noImageSize.height, loading: imgLoading, src: noImageSrc, width: noImageSize.width })) : (_jsxs(_Fragment, { children: [webpSrc && (_jsx("source", { height: imageHeight, srcSet: webpSrc, type: 'image/webp', width: imageWidth })), _jsx("img", { alt: alt, className: clsx(baseClassName, objectPositions[objectPosition]), css: aspectRatio, height: imageHeight, loading: imgLoading, onError: onError, src: src, width: imageWidth })] })) })));
};
